import React from 'react'
import { Decision } from '@/Components/Decisions/Decision';
import { AcknowledgedIcon, SeenIcon } from '@/Components/ui/Icons/TooltipIcon';
import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';
import { getStatusColor } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface DecisionPopupProps {
    decision: Decision;
}

const DecisionPopup: React.FC<DecisionPopupProps> = ({ decision }) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <div className='flex flex-col w-full text-2xl'>
                <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Work Package:</div><div>{decision.workPackage}</div></div>
                <div className='flex flex-col gap-4 mb-4'>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Raised By: </div> {decision.raisedBy ? decision.raisedBy : "N/A"} - {format(new Date(decision.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Decision Maker: </div><div>{decision.decider} - {format(new Date(decision.dateMade), dateformat)}</div><div className='flex flex-row my-auto px-2 space-x-2'>{decision.seen ? <SeenIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{decision.acknowledged ? <AcknowledgedIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Status: </div><div className={'w-48 text-center ' + getStatusColor(decision.status)}>{decision.status}</div></div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Decision:</div>
                    <div>{decision.description}</div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Notes:</div>
                    <div>{decision.notes && decision.notes}</div>
                </div>
            </div>
        );
    }

    return (
        <div className='flex flex-col gap-4'>
            <div className='flex flex-row'><div>Work Package:</div><div className='px-2'>{decision.workPackage}</div></div>
            <div className='flex flex-row my-4 justify-between'>
                <div className='flex flex-col gap-4 mr-8'>
                    <div className='flex flex-row'><div className="w-48">Raised By: </div> {decision.raisedBy} - {format(new Date(decision.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-48">Decision Maker: </div><div>{decision.decider} - {format(new Date(decision.dateMade), dateformat)}</div><div className='flex flex-row my-auto px-2 space-x-2'>{decision.seen ? <SeenIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{decision.acknowledged ? <AcknowledgedIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
                    <div className='flex flex-row'><div className="w-48">Status: </div><div className={'w-24 text-center ' + getStatusColor(decision.status)}>{decision.status}</div></div>
                </div>
            </div>
            <div>
                <div>Decision:</div>
                <div>{decision.description}</div>
            </div>
            <div>
                <div>Notes:</div>
                <div>{decision.notes && decision.notes}</div>
            </div>
        </div>
    )
}

export default DecisionPopup